<template>

  <b-form @submit.prevent>
    <b-row>
      <b-col md="4">
        <b-form-group
            label="Nom"
            label-for="libelle"

        >
          <b-form-input
              :class="{'is-invalid' : form_errors.libelle}"
              v-model="concession.libelle"
              id="libelle"
              placeholder="Nom du concession"
          />
          <small v-if="form_errors.libelle" class="text-danger">{{ form_errors.libelle[0] }}</small>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
            label="Groupe"
            label-for="groupe_id"
            :class="{'is-invalid' : form_errors.groupe_id}"
        >
          <v-select
              id="groupe_id"
              v-model="concession.groupe_id"
              :options="groupes"
              label="libelle"
              :reduce="groupe => groupe.id"
              placeholder="Sélectionner un groupe"
              clearable
          />
          <small v-if="form_errors.groupe_id" class="text-danger">{{ form_errors.groupe_id[0] }}</small>
        </b-form-group>
      </b-col>

      <b-col md="12">
        <b-form-group
            label="Adresse"
            label-for="Adresse"

        >
          <b-form-textarea
              v-model="concession.adresse"
              id="libelle"
              placeholder="Adresse du concession"
          />
          <small v-if="form_errors.adresse" class="text-danger">{{ form_errors.adresse[0] }}</small>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
            label="Code postal"
       

        >
          <b-form-input
              :class="{'is-invalid' : form_errors.codepostal}"
              v-model="concession.codepostal"
              id="codepostal"
              placeholder="Code postal"
          />
          <small v-if="form_errors.codepostal" class="text-danger">{{ form_errors.codepostal[0] }}</small>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
            label="Siret"


        >
          <b-form-input
              :class="{'is-invalid' : form_errors.siret}"
              v-model="concession.siret"
              id="codepostal"
              placeholder="Siret"
          />
          <small v-if="form_errors.siret" class="text-danger">{{ form_errors.siret[0] }}</small>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group label="RC (Registre de Commerce)">
          <b-form-input
              :class="{'is-invalid' : form_errors.rc}"
              v-model="concession.rc"
              placeholder="RC"
          />
          <small v-if="form_errors.rc" class="text-danger">{{ form_errors.rc[0] }}</small>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group label="IF (Identifiant Fiscal)">
          <b-form-input
              :class="{'is-invalid' : form_errors.identifiant_fiscal}"
              v-model="concession.identifiant_fiscal"
              placeholder="IF"
          />
          <small v-if="form_errors.identifiant_fiscal" class="text-danger">{{ form_errors.identifiant_fiscal[0] }}</small>
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-form-group
            label="Téléphone"


        >
          <b-form-input
              :class="{'is-invalid' : form_errors.telephone}"
              v-model="concession.telephone"
              id="codepostal"
              placeholder="Téléphone"
          />
          <small v-if="form_errors.telephone" class="text-danger">{{ form_errors.telephone[0] }}</small>
        </b-form-group>
      </b-col>
      <b-col md="6">
        <b-form-group
            label="Image CGV"
            label-for="image_cgv"
        >
          <div class="mb-2">
            <b-link :href="imageCgvExempleUrl" download="image_cgv_exemple.png" class="btn btn-outline-secondary btn-sm">
              <feather-icon icon="DownloadIcon" class="mr-50" />
              Télécharger l'image exemple
            </b-link>
            <small class="d-block text-muted mt-50">Téléchargez l'image exemple, modifiez-la, puis uploadez-la ci-dessous.</small>
          </div>
          <b-form-file
              id="image_cgv"
              :class="{'is-invalid' : form_errors.image_cgv}"
              accept="image/*"
              placeholder="Choisir une image..."
              drop-placeholder="Déposer le fichier ici..."
              @change="onImageCgvChange"
          />
          <small v-if="form_errors.image_cgv" class="text-danger">{{ form_errors.image_cgv[0] }}</small>
          <div v-if="imageCgvPreview" class="mt-2">
            <b-img :src="imageCgvPreview" thumbnail fluid alt="Aperçu Image CGV" style="max-width: 200px;" />
          </div>
          <div v-else-if="concession.image_cgv" class="mt-2">
            <b-img :src="concession.image_cgv" thumbnail fluid alt="Image CGV actuelle" style="max-width: 200px;" />
          </div>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group label="Texte CGV (bon de commande marchand B2B)">
          <small class="d-block text-muted mb-1">
            Conditions générales de vente affichées sur la page CGV du bon de commande marchand B2B.
          </small>
          <quill-editor
              v-model="concession.cgv_texte"
              :options="cgvEditorOptions"
          />
          <small v-if="form_errors.cgv_texte" class="text-danger">{{ form_errors.cgv_texte[0] }}</small>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-form-group label="Texte CGV (bon de commande de vente B2C)">
          <small class="d-block text-muted mb-1">
            Conditions générales de vente affichées sur la page CGV du bon de commande de vente B2C.
          </small>
          <quill-editor
              v-model="concession.cgv_texte_offre"
              :options="cgvEditorOptions"
          />
          <small v-if="form_errors.cgv_texte_offre" class="text-danger">{{ form_errors.cgv_texte_offre[0] }}</small>
        </b-form-group>
      </b-col>
      <b-col md="12">
        <b-button
            type="submit"
            variant="primary"
            class="mr-1"
            @click="submit"
        >
          Enregistrer
        </b-button>

      </b-col>
    </b-row>

  </b-form>
</template>

<script>
import BCardCode from '@core/components/b-card-code'
import {
  BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton, BFormFile, BImg, BFormTextarea, BLink,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

export default {
  name: 'ConcessionForm',
  components: {
    BCardCode,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormFile,
    BImg,
    BFormTextarea,
    BLink,
    vSelect,
    quillEditor,
  },
  directives: {
    Ripple,
  },
  props: {
    initialConcession: {
      default: false,
    }
  },
  methods: {
    fetchGroupes() {
      let _this = this;
      this.$store.dispatch('groupeModule/fetchAll').then(function (response) {
        _this.groupes = response.data;
      }).catch(function (error) {
        console.error('Error fetching groupes:', error);
      });
    },
    onImageCgvChange(e) {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imageCgvPreview = event.target.result;
          this.concession.image_cgv = event.target.result;
        };
        reader.readAsDataURL(file);
      }
    },
    submit() {
      let _this = this;
      _this.form_errors = {};
      this.$store.dispatch('concessionModule/store', this.concession).then(function (response) {
        _this.$emit('submited', response);
        _this.$router.push('/concessions');
        _this.$store.dispatch('initialConfigModule/fetchInitialConfig');
      }).catch(function (error) {
        if (error.response) {
          console.log(error.response.data);
          _this.form_errors = error.response.data.errors;
        }
      })
    }
  },
  created() {
    this.concession = {...this.initialConcession};
    this.fetchGroupes();
  },
  data() {
    return {
      concession: {
        libelle: '',
        groupe_id: null,
      },
      groupes: [],
      form_errors: {},
      imageCgvPreview: null,
      imageCgvExempleUrl: process.env.VUE_APP_BASE_URL + 'image_cgv_exemple.png',
      cgvEditorOptions: {
        theme: 'snow',
        placeholder: 'Saisissez le texte des conditions générales de vente...',
        modules: {
          toolbar: [
            [{ header: [1, 2, 3, false] }],
            ['bold', 'italic', 'underline'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            ['clean'],
          ],
        },
      },
    }
  },
}
/*
<ul class="chosen-results"><li class="active-result result-selected" data-option-array-index="1" style="">MR</li><li class="active-result" data-option-array-index="2" style="">COMPANY</li><li class="active-result" data-option-array-index="3" style="">GARAGE</li><li class="active-result" data-option-array-index="4" style="">MESSRS</li><li class="active-result" data-option-array-index="5" style="">MME</li><li class="active-result" data-option-array-index="6" style="">MMES</li><li class="active-result" data-option-array-index="7" style="">MS</li></ul>
 */
</script>
